import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=6e510640&scoped=true&"
import script from "./Benefits.vue?vue&type=script&lang=js&"
export * from "./Benefits.vue?vue&type=script&lang=js&"
import style0 from "./Benefits.vue?vue&type=style&index=0&id=6e510640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e510640",
  null
  
)

export default component.exports